import React, { useEffect, useState } from "react";
import { useForm, useFormState } from "react-hook-form";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import OutCome from "../../portfolio/childComponents/outcome";
import SingleOrderBuyImChild from "./SingleOrderBuyImChild";

const SingleOrderBuyIM = ({
  eventDetails,
  orderStatus,
  onClick,
  orderBookSelectedData,
  invested_amount,
  isDummy,
  closeSheet
}) => {
  const [YesSelected, setYesSelected] = useState(
    orderBookSelectedData?.callvalue === "Y"
  );

  const yesNoSelected = (isYes) => {
    if (isYes) {
      setYesSelected(true);
    } else {
      setYesSelected(false);
    }
  };

  const FormElement = React.useMemo(
    () => (
      <SingleOrderBuyImChild
        eventDetails={eventDetails}
        orderStatus={orderStatus}
        onClick={onClick}
        orderBookSelectedData={orderBookSelectedData}
        invested_amount={invested_amount}
        YesSelected={YesSelected}
        isDummy={isDummy}
        yesNoSelected={yesNoSelected}
        closeSheet={closeSheet}
      />
    ),
    [YesSelected]
  );

  return (
    <View style={{ paddingHorizontal: 15 }}>
      <>{FormElement}</>
    </View>
  );
};

export default SingleOrderBuyIM;

const styles = StyleSheet.create({
  maxShareText: {
    ...globalFontStyle.appFontSmallTextBold,
    color: Colors.tradexBlue,
  },
  fieldBottomText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.grey2,
  },
});
